import Api from '../api'
const END_POINT = 'public/cities';

export default {
    state: {
        cities: []
    },

    getters: {
        getCities: state => state.cities
    },

    mutations: {
        setCities: (state, cities) => state.cities = cities,
    },

    actions: {
        async fetchCities({commit}){
            const response = await Api.get(END_POINT);
            commit('setCities', response.body.data);
        },
    }
}